import { render } from "./FooterBar.vue?vue&type=template&id=b8e1c35a"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/doc_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__